import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ro_RO',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '1138bae0-0190-4d7d-b61c-e909b3b44ab4',
  ''
);
